export default __webpack_public_path__ + "static/media/IMG_4557-min.73487ce1.JPG";